module.exports = __webpack_public_path__ + "img/linkedin-entia.a642b47f.svg";